import site from 'pro/config/site';

const PHONE_WIDTH_LIST = [100, 200, 400, 500, 750];

export function transToDynamicPath(enumPath: string): string {
    return enumPath.split('/').map(item => {
        return item.startsWith(':')
            ? `[${item.replace(':', '')}]`
            : item;
    }).join('/');
}

export function transImageSrc(src: string | string[] | undefined, width?: number | string, ratio?: number): string {
    src = Array.isArray(src) ? src[0] : src;
    if (!src) {
        src = site.errorImage as string || 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    } else {
        if (src.startsWith('asset/') || src.startsWith('file-asset/')) {
            src = `${site.cdnRoot}${src}`;
        }
        if (typeof width === 'number') {
            ratio = ratio || (process.env.NEXT_PUBLIC_TERMINAL === 'm' ? 4 : 2);
            src = src.replace(/\/width-\d+\//, `/width-${width * ratio}/`);
        }
    }
    return src;
}

export function getPhoneSrcset(src: any): string {
    const arr: string[] = PHONE_WIDTH_LIST.map(screenWidth => {
        const screenSrc = transImageSrc(src, screenWidth, 1);
        return `${screenSrc} ${screenWidth}w`;
    });
    return arr.join(',');
}

export function getCdnUrl(src: string): string {
    if (!src || typeof src !== 'string') {
        return '';
    }
    return src.startsWith('http') || src.startsWith('images') || src.startsWith('//') ? src : `${site.cdnRoot}${src.replace(/^\//, '')}`;
}